export const SELECT_MODES = {
    NONE: 'NONE',
    SINGLE: 'SINGLE',
    MULTI: 'MULTI',
};
export const MULTI_SELECT_STATUS = {
    NONE: 'NONE',
    SOME: 'SOME',
    ALL: 'ALL',
};

export const SORT_OPTIONS = {
    ASC_SORT: 'ASC',
    DESC_SORT: 'DESC',
};

export const DETAIL_MODES = {
    EDIT: 'EDIT',
    VIEW: 'VIEW',
    NEW: 'NEW',
};
